export default { "none":"None", "send":"SEND", "sendMessage":"SEND MESSAGE", "sending":"SENDING..." } as const;
